<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="编号" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.type_id"  clearable filterable  placeholder="报销类型">
                                        <Option :value="item.type_id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.project_id"  clearable filterable  placeholder="报销项目">
                                        <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.partner_id"  clearable filterable  placeholder="合作商">
                                        <Option :value="item.partner_id" v-for="(item,index) in partnerList" :key="index">{{item.real_name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable placeholder="状态" class="search-select">
                                        <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <DatePicker size="small" v-model="search.time" clearable type="daterange" format="yyyy-MM-dd"  placeholder="报销日期" />
                                    &nbsp;&nbsp;
                                    <ButtonGroup >
                                        <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                        <Button size="small" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>

                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 发起报销</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #sn="{ row }">
                                    <div class="d-width text-primary cursor" :title="row.sn" @click="showData(row.id)">
                                        <span>{{row.sn}}</span>
                                    </div>
                                </template>
                                <template #mode_id="{ row }">
                                    <Tag color="orange" v-if="row.mode_id == 2">项目报销</Tag>
                                    <Tag color="blue" v-else>普通报销</Tag>
                                </template>
                                <template #type_id="{ row }">
                                    <Tag>{{row.type_name}}</Tag>
                                </template>
                                <template #money="{ row }">
                                    <div class="d-width" :title="row.money?row.money:'0.00'">
                                        <strong class="text-primary">{{row.money?row.money:'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #pay_money="{ row }">
                                    <div class="d-width" :title="row.pay_money?row.buyer_money:'0.00'">
                                        <strong class="text-success">{{row.pay_money?row.pay_money:'0.00'}}</strong>
                                    </div>
                                </template>
                                <template #pay_time="{ row }">
                                    {{row.pay_time ?? '-'}}
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 3" color="orange" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 5" color="green" :text="row.status_name" />
                                    <Poptip v-else-if="row.status === 4 || row.status === 2" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                        <Badge color="red" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <template #pay_account="{ row }">
                                    <div class="d-width" :title="row.pay_account ?? '-'">
                                        {{row.pay_account ?? '-'}}
                                    </div>
                                </template>
                                <template #project_id="{ row }">
                                    <div class="d-width" :title="row.project_name ?? '-'">
                                        {{row.project_name ?? '-'}}
                                    </div>
                                </template>
                                <template #remark="{ row }">
                                    <div class="d-width" :title="row.remark ?? '-'">
                                        {{row.remark ?? '-'}}
                                    </div>
                                </template>
                                <template #action="{ row, index }">
                                    <a class="text-font-sm text-violet" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2) && row.status === 1 " @click="examineData(row.id)">审批</a>
                                    <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2) && row.status === 1 "/>
                                    <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 3 " @click="payData(row.id)">打款</a>
                                    <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && row.status === 3 "/>
                                    <a class="text-font-sm text-primary" v-if="row.status !== 5 && ($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2)" @click="editData(row.id)">编辑</a>
                                    <Divider type="vertical" v-if="row.status !== 5 && ($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2)"/>
                                    <a class="text-font-sm text-danger" v-if="row.status !== 5 && $store.state.userinfo.admin_id === row.apply_id" @click="deleteData(row.id, index)">删除</a>
                                    <a class="text-font-sm text-success" @click="showData(row.id)">查看</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 项目支出审批  -->
                    <examine-modal v-if="is_expend_examine" ref="ExamineExpendRef" @trueHandler="saveData"></examine-modal>

                    <!-- 项目支出财务打款  -->
                    <pay-expend-modal v-if="is_expend_pay" ref="PayExpendRef" @trueHandler="saveData"></pay-expend-modal>

                    <!-- 项目支出详情  -->
                    <show-expend-modal v-if="is_show" ref="ShowExpendRef"></show-expend-modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "../PartnerCreate";
import ExamineModal from "../Examine";
import PayExpendModal from "../Pay";
import ShowExpendModal from "../Show";
import {deleteExpense, getExpenseConfig, getExpensePartnerList} from "@/apis/expense";
export default {
    name: "ExpenseIndex",
    components: {
        Headers, Side, AddModal, ExamineModal, PayExpendModal, ShowExpendModal
    },
    data () {
        return {
            typeList: [],
            partnerList: [],
            statusList: [],
            projectList: [],

            search: {
                name: '',
                partner_id: '',
                project_id: '',
                type_id: '',
                status: '',
                time: []
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    title: '申请日期',
                    key: 'apply_time',
                    width: 160,
                    fixed: 'left'
                },
                {
                    title: '编号',
                    key: 'sn',
                    slot: 'sn',
                    width: 160,
                },
                {
                    title: '报销模式',
                    key: 'mode_id',
                    slot: 'mode_id',
                    width: 140,
                },
                {
                    title: '报销类型',
                    key: 'type_id',
                    slot: 'type_id',
                    width: 140,
                },
                {
                    title: '报销金额',
                    key: 'money',
                    slot: 'money',
                    width: 120,
                },
                {
                    title: '申请人',
                    key: 'apply_name',
                    width:120
                },
                {
                    title: '状态',
                    key: 'status',
                    slot : 'status',
                    width:120
                },
                {
                    title: '支付金额',
                    key: 'pay_money',
                    slot: 'pay_money',
                    width: 120
                },
                {
                    title: '支付时间',
                    key: 'pay_time',
                    slot: 'pay_time',
                    width: 120
                },
                {
                    title: '支付账号',
                    key: 'pay_account',
                    slot: 'pay_account',
                    minWidth:160
                },
                {
                    title: '报销项目',
                    key: 'project_id',
                    slot: 'project_id',
                    width: 160,
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark',
                    minWidth:120
                },
                {
                    title: '更新',
                    key: 'update_time',
                    width:150
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    width : 150,
                    fixed : 'right'
                }
            ],
            is_create : false,
            is_expend_examine : false,
            is_expend_pay : false,
            is_show : false,

        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {

        /**
         功能：
         time: 2026/1/6 15:14
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                project_id: '',
                partner_id: '',
                type_id: '',
                status: '',
                time: []
            };
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 14:05
         **/
        getConfig(){
            let that = this;
            getExpenseConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.statusList = e.data.statusList ?? [];
                that.projectList = e.data.projectList ?? [];
                that.partnerList = e.data.partnerList ?? [];
            })
        },
        /**
         功能：列表
         time: 2025-09-01 18:09:28
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
          getExpensePartnerList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：分页
         time: 2025-54-03 09:54:43
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },

        /**
         功能：
         time: 2026/1/7 14:12
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：
         time: 2026/1/7 14:12
         **/
        editData(id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(id);
            })
        },
        /**
         功能：
         time: 2026/1/7 14:44
         **/
        showData(id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowExpendRef.show(id);
            })
        },
        /**
         功能：
         time: 2026/1/7 14:17
         **/
        examineData(id){
            let that = this;
            that.is_expend_examine = true;
            setTimeout(function(){
                that.$refs.ExamineExpendRef.show(id);
            })
        },
        /**
         功能：
         time: 2026/1/7 14:30
         **/
        payData(id){
            let that = this;
            that.is_expend_pay = true;
            setTimeout(function(){
                that.$refs.PayExpendRef.show(id);
            })
        },
        /**
         功能：
         time: 2026/1/7 14:30
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：
         time: 2026/1/7 14:11
         **/
        deleteData(id, index){
            let that = this;
            if(!id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteExpense(id).then( e =>{
                        that.dataList.data.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
